import { createGqlQuery } from '@/lib/query-helper'

import { graphql } from '@/gql'

const authLogin = createGqlQuery({
  key: 'authLogin',
  query: graphql(`
    mutation Login($request: LoginRequest!) {
      login(request: $request) {
        token
        user {
          id
          name
          email
          role
          confirmation
        }
      }
    }
  `),
})

const authRegister = createGqlQuery({
  key: 'authRegister',
  query: graphql(`
    mutation Register($request: RegisterRequest!) {
      register(request: $request) {
        token
        user {
          id
          name
          email
          role
        }
      }
    }
  `),
})

const authResendOtp = createGqlQuery({
  key: 'authResendOtp',
  query: graphql(`
    mutation ResendOtp($req: ResendOTPRequest!) {
      resendOTP(request: $req) {
        success
      }
    }
  `),
})

const authVerifyOtp = createGqlQuery({
  key: 'authVerifyOtp',
  query: graphql(`
    mutation VerifyOTP($req: VerifyOTPRequest!) {
      verifyOTP(request: $req) {
        token
        user {
          id
          name
          email
          phone
          access_type
        }
      }
    }
  `),
})

const authLoginGoogle = createGqlQuery({
  key: 'authLoginGoogle',
  query: graphql(`
    mutation LoginGoogle($req: GoogleLoginRequest!) {
      loginWithGoogle(request: $req) {
        token
        user {
          id
          name
          email
          role
          confirmation
        }
      }
    }
  `),
})

const authForgotPassword = createGqlQuery({
  key: 'authForgotPassword',
  query: graphql(`
    mutation AuthForgotPassword($req: SendResetEmailLinkRequest!) {
      sendResetEmailLink(request: $req) {
        success
      }
    }
  `),
})

const authNewPassword = createGqlQuery({
  key: 'authNewPassword',
  query: graphql(`
    mutation AuthNewPassword($req: ResetPasswordRequest!) {
      resetPassword(request: $req) {
        success
      }
    }
  `),
})

export {
  authLogin,
  authRegister,
  authResendOtp,
  authVerifyOtp,
  authLoginGoogle,
  authForgotPassword,
  authNewPassword,
}
